const sections = document.querySelectorAll(".shop-knife-by-type-section");
const menuItems = [...document.querySelectorAll(".shop-tabs a")];

let prevYPosition = 0;
let direction = "up";

const options = {
  threshold: 0.3,
};

const getTargetSection = (entry) => {
  const index = sections.findIndex((section) => section == entry.target);
  if (index >= sections.length - 1) {
    return entry.target;
  } else {
    return sections[index + 1];
  }
};

const shouldUpdate = (entry) => {
  if (direction === "down" && !entry.isIntersecting) {
    return true;
  }
  if (direction === "up" && entry.isIntersecting) {
    return true;
  }
  return false;
};

const updateMarker = (target) => {
  const id = target.id;
  if (!id) return;

  menuItems.forEach((el) => {
    el.classList.remove("active");
  });

  let link = menuItems.find((el) => {
    return el.getAttribute("href") === `#${id}`;
  });

  link = link || menuItems[0];
  link.classList.add("active");
};

const onIntersect = (entries, observer) => {
  entries.forEach((entry) => {
    if (document.body.scrollTop > prevYPosition) {
      direction = "down";
    } else {
      direction = "up";
    }

    prevYPosition = document.body.scrollTop;
    const target =
      direction === "down" ? getTargetSection(entry) : entry.target;

    if (shouldUpdate(entry)) {
      updateMarker(target);
    }
  });
};

updateMarker(sections[0]);

const observer = new IntersectionObserver(onIntersect, options);

sections.forEach((section) => {
  observer.observe(section);
});
